/*
 * kelltoncommerce
 * version 1.0
 * http://www.kelltoncommerce.com
 *
 * Copyright (c) 2023  kellton tech solution limited
 * Author kellton ltd <support@kellton.com>
 * Licensed under the MIT license.
 */

// store
import {type} from '../../shared/utility/utilityHelpers';
import { Action } from '@ngrx/store';

export const ActionTypes = {
  // Mediada upload
  PURCHASED_CUSTOMER_LIST: type('[Purchased-customer] purchased Customer List'),
  PURCHASED_CUSTOMER_LIST_SUCCESS: type('[Purchased-customer] purchased Customer List Success'),
  PURCHASED_CUSTOMER_LIST_FAIL: type('[Purchased-customer] purchased Customer List Fail'),

  PURCHASED_CUSTOMER_LIST_COUNT: type('[purchased count] purchased Customer List Count'),
  PURCHASED_CUSTOMER_LIST_COUNT_SUCCESS: type('[purchased count] purchased Customer List Count Success'),
  PURCHASED_CUSTOMER_LIST_COUNT_FAIL: type('[purchased count] purchased Customer List Count Fail'),

};

// MEDIA UPLOAD
export class purchasedCustomer implements Action {
  type = ActionTypes.PURCHASED_CUSTOMER_LIST;

  constructor(public payload: any) {}
}

export class purchasedCustomerSuccessAction implements Action {
  type = ActionTypes.PURCHASED_CUSTOMER_LIST_SUCCESS;

  constructor(public payload: any) {}
}

export class purchasedCustomerFailAction implements Action {
  type = ActionTypes.PURCHASED_CUSTOMER_LIST_FAIL;

  constructor(public payload: any = null) {}
}

export class PurchasedCount implements Action {
  type = ActionTypes.PURCHASED_CUSTOMER_LIST_COUNT;

  constructor(public payload: any) { }
}

export class PurchasedCountSuccess implements Action {
  type = ActionTypes.PURCHASED_CUSTOMER_LIST_COUNT_SUCCESS;

  constructor(public payload: any) { }
}

export class PurchasedCountFail implements Action {
  type = ActionTypes.PURCHASED_CUSTOMER_LIST_COUNT_FAIL;

  constructor(public payload: any = null) { }
}